import { DialogBackdrop } from "../../../../../ui/dialog/backdrop.js";
import { DialogPopup } from "../../../../../ui/dialog/popup.js";
import { ErrorDialogClose } from "../../../../../ui/error-dialog/close.js";
import { ErrorDialogDescription } from "../../../../../ui/error-dialog/description.js";
import { ErrorDialogRoot } from "../../../../../ui/error-dialog/root.js";
import { ErrorDialogTitle } from "../../../../../ui/error-dialog/title.js";
import { Button } from "../buttons/button.js";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/internal/skins/shared/components/feedback/error-dialog.tsx
/** @jsxImportSource react */
function ErrorDialog() {
	return /* @__PURE__ */ jsxs(ErrorDialogRoot, { children: [/* @__PURE__ */ jsx(DialogBackdrop, { className: "media-dialog-backdrop" }), /* @__PURE__ */ jsxs(DialogPopup, {
		className: "media-dialog-popup",
		children: [/* @__PURE__ */ jsxs("div", {
			className: "media-dialog-content",
			children: [/* @__PURE__ */ jsx(ErrorDialogTitle, { className: "media-dialog-title" }), /* @__PURE__ */ jsx(ErrorDialogDescription, { className: "media-dialog-description" })]
		}), /* @__PURE__ */ jsx("div", {
			className: "media-dialog-actions",
			children: /* @__PURE__ */ jsx(ErrorDialogClose, {
				render: /* @__PURE__ */ jsx(Button, {}),
				className: "media-dialog-close"
			})
		})]
	})] });
}
//#endregion
export { ErrorDialog };

//# sourceMappingURL=error-dialog.js.map